import React from 'react';
import Asterisk from './Asterisk';

/**
 * @typedef {object} SelectorTitleProps
 * @property {React.ReactNode} [title]
 * @property {boolean} [showAsterisk]
 * @property {string} [testId]
 */

/**
 * @param {SelectorTitleProps} props
 */
export const SelectorTitle = props => {
  const { title, testId, showAsterisk } = props;

  if (!title) {
    return null;
  }

  if (React.isValidElement(title)) {
    return title;
  }

  if (typeof title === 'string') {
    return (
      <h4 className='field-title' data-testid={`field-title-${testId}`}>
        {title}
        {showAsterisk && <Asterisk />}
      </h4>
    );
  }
};
